import { useState } from 'react';
import error from "../images/icon-error.svg";

function Footer() {
  const [inputValue, setInputValue] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  
  const handleSubmit = (e) => {
    e.preventDefault();
    // validate input value here
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(inputValue)) {
      setErrorMessage(`Whoops! ${inputValue} is not a valid email address`);
    } else {
      // do something else, like submit the form or clear the error message
    }
  };
  
  const handleInputChange = (e) => {
    setInputValue(e.target.value);
    setErrorMessage('');
  };
  
  return (
    <div className="footer">
      <h5 className="heading-1">
        35,000+ already joined
      </h5>
      <h2 className="heading-2">
        Stay up-to-date with what we’re doing
      </h2>
      <form onSubmit={handleSubmit}>
        <div className="input-container">
          <input 
            type="text" 
            className={`input ${errorMessage ? 'error' : ''}`}
            placeholder="Enter your email address"
            value={inputValue}
            onChange={handleInputChange}
          />
          {errorMessage && <img src={error} alt="Error icon" className="error-icon" />}
        </div>
        {errorMessage && <p className="error-message">{errorMessage}</p>}
        <input type="submit" value="Contact Us" className="submit" />
      </form>
    </div>
    
  );
}

export default Footer;
